import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative mx-auto mt-12 max-w-[1400px] lg:mt-20 lg:px-4',
    grid: 'grid grid-cols-2 gap-2 lg:flex lg:gap-3',
    card: 'landing-glass relative z-1 flex items-center justify-center rounded-[20px] border-x-0 bg-white/10 p-5 lg:min-h-[215px] lg:rounded-[40px] lg:p-8',
    cardLogos: 'lg:w-[663px] lg:max-w-[47%] lg:shrink-0',
    cardStat: 'lg:flex-1 xl:min-w-[320px]',
    cardWide: 'col-span-2 lg:col-span-1',
    logos: 'flex flex-col items-center gap-3 lg:flex-row lg:gap-8 xl:gap-10',
    galchonokLogo: 'h-auto w-[94px] lg:w-[149px]',
    biodermaLogo: 'text-brand-bioderma h-auto w-[117px] lg:w-[186px]',
    stat: 'flex flex-col items-center justify-center text-center',
    statValue:
      'text-brand-bioderma text-[32px] leading-[1.2] font-medium lg:text-[40px]',
    statLabel:
      'text-brand-bioderma mt-1 max-w-[280px] text-[16px] leading-[1.2] lg:text-[20px]',
    cross:
      'text-brand-bioderma shrink-0 text-[16px] leading-none lg:text-[20px]'
  }
});
